export const discussions = [
  {
    id: "d-1",
    user: "吃瓜不吐籽",
    initial: "瓜",
    content: "视频那么糊也能叫实锤吗？还是先等当事人或者工作室的说法吧，别急着下结论。",
    likes: 1284,
    replies: 96,
    time: "18 分钟前",
    topic: "顶流恋情传闻",
  },
  {
    id: "d-2",
    user: "理智冲浪选手",
    initial: "理",
    content: "带货翻车这事的关键是售后通道有没有真的打通，具体怎么退、多久到账，这些才是有用的信息。",
    likes: 936,
    replies: 154,
    time: "42 分钟前",
    topic: "美妆博主争议",
  },
  {
    id: "d-3",
    user: "综艺考古员",
    initial: "综",
    content: "节目组都回应录制顺利了，那些空镜配图的帖真的别再转了，容易误伤。吃瓜也要讲基本法。",
    likes: 712,
    replies: 61,
    time: "1 小时前",
    topic: "综艺录制传闻",
  },
  {
    id: "d-4",
    user: "剧粉小透明",
    initial: "剧",
    content: "换角这事等官宣吧，立项信息还没改呢。营销号的消息我现在只信一半。",
    likes: 508,
    replies: 38,
    time: "2 小时前",
    topic: "古装剧换角",
  },
  {
    id: "d-5",
    user: "深夜刷手机",
    initial: "夜",
    content: "不得不说整理得挺全的，时间线和双方回应都摆出来了，比自己翻一堆碎片帖子清楚多了。",
    likes: 436,
    replies: 22,
    time: "3 小时前",
    topic: "站点讨论",
  },
  {
    id: "d-6",
    user: "只玩梗不下场",
    initial: "梗",
    content: "来学习黑话的，词典那块挺有意思，终于搞懂「拉踩」和「路人缘」到底是啥意思了。",
    likes: 389,
    replies: 17,
    time: "4 小时前",
    topic: "瓜田词典",
  },
];

export const glossary = [
  {
    term: "塌房",
    desc: "指明星或网红因负面事件导致人设崩塌、口碑急速下滑，粉丝大规模脱粉的现象。",
    category: "现象",
  },
  {
    term: "路人缘",
    desc: "指普通观众（非粉丝）对某位艺人的整体好感度，通常由作品表现、公开言行与日常形象共同决定。",
    category: "评价",
  },
  {
    term: "拉踩",
    desc: "在对比中刻意抬高一方、贬低另一方的发言方式，常见于粉丝群体间的争论，平台多不鼓励此类内容。",
    category: "行为",
  },
  {
    term: "营业",
    desc: "原指艺人配合宣传，后泛指明星、网红主动发布内容与粉丝互动；「不营业」则指长期不更新动态。",
    category: "行为",
  },
  {
    term: "实锤",
    desc: "指能直接证明某事的证据，如清晰影像、聊天记录或当事人承认。仅有模糊截图或转述通常不算实锤。",
    category: "证据",
  },
  {
    term: "考古",
    desc: "指翻找艺人早年公开的照片、视频或发言进行讨论。涉及的内容多为公开资料，需注意时间背景。",
    category: "行为",
  },
  {
    term: "数据女工",
    desc: "对长期为偶像打榜、控评、做数据的粉丝的戏称，带有调侃意味，也反映粉丝群体的组织化倾向。",
    category: "群体",
  },
  {
    term: "解约传闻",
    desc: "指关于艺人与品牌或经纪公司提前结束合作的传言。未获官方公告前，通常只能算未经证实的信息。",
    category: "商业",
  },
  {
    term: "空镜配图",
    desc: "指爆料帖中只用空场景、无人物画面作为配图的写法，因缺乏直接信息，常被提醒谨慎对待。",
    category: "辨别",
  },
];

export const faq = [
  {
    q: "「黑料」这个词在这里指什么？",
    a: "在这里它泛指娱乐圈与网红圈中引发讨论的负面传闻、争议事件与舆论热点，是一个娱乐向的说法。本站做的是信息汇总与线索整理，不代表对任何事件的定性。",
  },
  {
    q: "站内的爆料内容都是真的吗？",
    a: "不全是。页面内容多为网络公开讨论与网友投稿的整理，其中包含大量未获当事人或官方确认的传闻。我们会在每条内容旁标注来源口径，请以官方公告和权威媒体为准。",
  },
  {
    q: "内容多久更新一次？",
    a: "「最新爆料」时间线按日更新，尽量保留时间、分类与一句话说明，方便你按时间顺序了解事件的推进过程。已经澄清或反转的内容，也会尽量补充后续说明。",
  },
  {
    q: "分类筛选是怎么用的？",
    a: "在「爆料分类」区域点击明星、网红、综艺、影视等标签，即可只看该类的当前条目；再点「全部」可以恢复完整列表。筛选只作用于本页已经有内容，无需等待加载。",
  },
  {
    q: "可以自己投稿爆料吗？",
    a: "目前站点专注于内容浏览与汇总，暂不提供投稿入口。如果你未来需要稿件投递或线索提交功能，可以再加一个投稿表单来实现。",
  },
  {
    q: "看到不实内容该怎么办？",
    a: "如果内容与事实不符，请优先通过平台举报渠道反馈，并保留相关证据。站内所有示例内容均为演示用途，不针对任何真实个人。",
  },
];

export const siteStats = [
  { label: "今日更新条目", value: "128" },
  { label: "收录人物档案", value: "3,600+" },
  { label: "累计专题合集", value: "240+" },
  { label: "吃瓜热议数", value: "18.6w" },
];

export const sectionNav = [
  { id: "hot", label: "今日热瓜" },
  { id: "timeline", label: "最新爆料" },
  { id: "expose", label: "爆料分类" },
  { id: "people", label: "人物档案" },
  { id: "topics", label: "热门专题" },
  { id: "ranking", label: "热度榜" },
  { id: "glossary", label: "瓜田词典" },
  { id: "faq", label: "答疑" },
];